import { useState, useContext } from "react";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  Avatar,
  Grid,
} from "@material-ui/core";

import {
  AddShoppingCart,
  RotateLeft,
  FlightLand,
  Close,
} from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";

import {
  HeaderModal,
  TextList,
  ModalAutomatica,
  ButtonList,
  ListAvatar,
} from "../styles/Emissao";

import WizardEmissaoVenda from "./WizardEmissaoVenda";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import WizardEmissaoCompra from "./WizardEmissaoCompra";
import { EmissaoContext } from "../contexts/EmissaoContext";

const ModalEmissaoMontAutomatica = ({
  setModalAutomaticaOpen,
  modalAutomaticaOpen,
}) => {
  const {
    setSelectedSupplier,
    setSelectedPurchaseNf,
    setSelectedPurchaseItems,
    setPurchaseStartDate,
    setPurchaseFinalDate,
    setFirstSearch,
  } = useContext(EmissaoContext);

  const { queryParams } = useContext(QueryParamsContext);
  const [openWizardVenda, setOpenWizardVenda] = useState(false);
  const [openWizardCompra, setOpenWizardCompra] = useState(false);
  const [listOptions, setListOptions] = useState(true);
  const [width, setWidth] = useState("sm");
  const [demandOptions, setDemandOptions] = useState(null);

  const handleClose = () => {
    setDemandOptions(null);
    setModalAutomaticaOpen(false);
    setSelectedSupplier([]);
    setSelectedPurchaseNf([]);
    setSelectedPurchaseItems([]);
    setPurchaseStartDate("");
    setPurchaseFinalDate("");
    setFirstSearch(true);
  };

  const handleOpenAndClose = (setOpen, options = {}) => {
    setWidth("lg");
    setListOptions(false);
    setDemandOptions(options);

    setOpen(true);
  };

  const additionalOptions = ![57, 58, 59].includes(
    parseInt(queryParams?.idversao || "0")
  )
    ? [
        {
          title: "NF-e de Devolução a partir de uma Devolução/Defeito",
          action: () =>
            handleOpenAndClose(setOpenWizardVenda, {
              tipo: ["D", "F"],
              statusvenda: ["Devolução", "Devolução por Defeito"],
              steps: [
                "Seleção de Cliente",
                "Seleção da Devolução",
                "Confirmação dos Itens",
              ],
            }),
          icon: <RotateLeft />,
        },
      ]
    : [];

  const automaticAssemblyImportDeclaration = [
    {
      title: "NF-e de Entrada a partir de Declaração de Importação",
      action: () =>
        handleOpenAndClose(setOpenWizardVenda, {
          tipo: ["DI"],
          body: "di",
          steps: ["Seleção de DI", "Seleção de Adições"],
        }),
      icon: <FlightLand />,
    },
  ];

  const purchaseInvoiceOptions = ![57, 58, 59].includes(
    parseInt(queryParams?.idversao || "0")
  )
    ? [
        {
          title: "NF-E DE DEVOLUÇÃO A PARTIR DE UMA NOTA FISCAL DE COMPRAS",
          action: () =>
            handleOpenAndClose(setOpenWizardCompra, {
              tipo: ["P"],
              body: "compra",
              steps: [
                "Seleção de Fornecedor",
                "Seleção da NF-e",
                "Confirmação dos Itens",
              ],
            }),
          icon: <RotateLeft />,
        },
      ]
    : [];

  const automaticMontageOptionList = [
    {
      title: "NF-e de Venda á partir de uma Venda",
      action: () =>
        handleOpenAndClose(setOpenWizardVenda, {
          tipo: ["V"],
          statusvenda: ["Venda"],
          steps: [
            "Seleção de Cliente",
            "Seleção do Pedido/Venda",
            "Confirmação dos Itens",
            "Financeiro",
          ],
        }),
      icon: <AddShoppingCart />,
    },
    ...additionalOptions,
    ...automaticAssemblyImportDeclaration,
    ...purchaseInvoiceOptions,
  ];

  return (
    <Dialog
      fullWidth={true}
      maxWidth={width}
      open={modalAutomaticaOpen}
      onClose={handleClose}
      aria-labelledby="dialog-montagem-automatica"
      disableEnforceFocus
    >
      <HeaderModal>
        <DialogTitle id="dialog-montagem-automatica">
          <Chip
            label={
              <>
                <Grid item sm>
                  <span> Montagem Automática da Nota Fiscal </span>
                </Grid>
                <Grid item>
                  <Close onClick={handleClose} />
                </Grid>
              </>
            }
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        {listOptions && (
          <ModalAutomatica>
            <List dense={false}>
              {automaticMontageOptionList.map((item, key) => (
                <ListItem key={key}>
                  <ButtonList onClick={item.action}>
                    <ListAvatar>
                      <Avatar>{item.icon}</Avatar>
                    </ListAvatar>
                    <TextList primary={item.title} />
                  </ButtonList>
                </ListItem>
              ))}
            </List>
          </ModalAutomatica>
        )}
        {openWizardVenda && (
          <WizardEmissaoVenda
            openWizardVenda={openWizardVenda}
            setOpenWizardVenda={setOpenWizardVenda}
            setOpenModal={setModalAutomaticaOpen}
            demandOptions={demandOptions}
          />
        )}

        {openWizardCompra && (
          <WizardEmissaoCompra
            setOpenWizardCompra={setOpenWizardCompra}
            setOpenModal={setModalAutomaticaOpen}
            demandOptions={demandOptions}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalEmissaoMontAutomatica;
